import { actionCreatorFactory } from "typescript-fsa";

import { ModelPath } from "@com.mgmtp.a12.base/base-model-api/lib/main/model";
import { ActivityActions } from "@com.mgmtp.a12.client/client-core/lib/core/activity";

const factory = actionCreatorFactory("MODULF");

export const sendEmailAction = factory<SendEmailPayload>("SEND_EMAIL");

export interface SendEmailPayload extends ActivityActions.ActivityActionPayload {
	readonly buttonPath: ModelPath;
	readonly bundId: boolean;
}

export const emailConfirmation = factory<EmailConfirmationPayload>("EMAIL_CONFIRMATION");

export interface EmailConfirmationPayload {
	readonly isConfirmed: boolean;
}
